"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordReset = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
const usePasswordVerifyResetToken_1 = require("./usePasswordVerifyResetToken");
function usePasswordReset() {
    const _a = (0, usePasswordVerifyResetToken_1.usePasswordVerifyResetToken)(), { user, doVerifyResetToken } = _a, verify = __rest(_a, ["user", "doVerifyResetToken"]);
    const { data: success, isLoading: isLoadingPasswordReset, error, put } = (0, core_ui_1.useApiPut)('users/password/reset');
    const isLoading = isLoadingPasswordReset || verify.isLoading;
    const doPasswordReset = (0, react_1.useCallback)((password, token) => {
        put({ password, token });
    }, [put]);
    return {
        user,
        success,
        isLoading,
        error,
        verifyError: verify.error,
        doPasswordReset,
        doVerifyResetToken
    };
}
exports.usePasswordReset = usePasswordReset;
//# sourceMappingURL=usePasswordReset.js.map